export default __webpack_public_path__ + "static/media/David_Square.c322e549.jpeg";